(() => {
  function init(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    document.querySelectorAll('[data-cart-btn]').forEach(link => {
      ['aria-haspopup', 'aria-controls', 'aria-expanded'].forEach(name => link.removeAttribute(name));
    });
    const form = root.querySelector('.ct-order__form');
    const input = root.querySelector('[data-order-quantity]');
    const sticky = root.querySelector('[data-sticky-purchase]');
    const hero = root.querySelector('.ct-hero');
    const order = root.querySelector('.ct-order__details');
    const base = root.dataset.rootUrl || '/';
    const currency = root.dataset.currency || 'MXN';
    const price = Number(root.dataset.price);
    const servings = Number(root.dataset.servings);
    const maximum = Math.max(1, Number(root.dataset.quantityMax) || 1);
    const money = cents => `${new Intl.NumberFormat('es-MX', { style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2 }).format(cents / 100)} ${currency}`;

    if (sticky && hero && order && 'IntersectionObserver' in window) {
      let pastHero = false;
      let orderVisible = false;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          if (entry.target === order) orderVisible = entry.isIntersecting;
        });
        sticky.hidden = !pastHero || orderVisible;
      }, { threshold: 0 });
      observer.observe(hero);
      observer.observe(order);
    }

    if (!form || !input) return;
    const status = root.querySelector('[data-order-status]');
    const error = root.querySelector('[data-order-error]');
    const success = root.querySelector('[data-order-success]');
    const submitButtons = [...form.querySelectorAll('button[type="submit"]')];
    const stepButtons = [...form.querySelectorAll('[data-step]')];
    let pending = false;

    function quantity() {
      return Number(input.value);
    }
    function updateTotals() {
      const q = quantity();
      const valid = input.validity.valid && Number.isInteger(q) && q >= 1 && q <= maximum;
      root.querySelector('[data-order-total]').textContent = valid ? money(price * q) : 'Elige una cantidad válida';
      root.querySelector('[data-order-servings]').textContent = valid ? String(servings * q) : '';
      stepButtons.forEach(button => {
        button.disabled = pending || (Number(button.dataset.step) < 0 ? q <= 1 : q >= maximum);
      });
    }
    input.addEventListener('input', () => {
      input.setCustomValidity('');
      success.hidden = true;
      status.textContent = '';
      updateTotals();
    });
    input.addEventListener('change', updateTotals);
    stepButtons.forEach(button => button.addEventListener('click', () => {
      input.value = String(Math.min(maximum, Math.max(1, (Number.isFinite(quantity()) ? Math.trunc(quantity()) : 1) + Number(button.dataset.step))));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }));
    updateTotals();

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (pending) return;
      const q = quantity();
      if (!Number.isInteger(q) || q < 1 || q > maximum) {
        input.setCustomValidity(`Elige entre 1 y ${maximum} frascos.`);
        input.reportValidity();
        return;
      }
      if (!form.reportValidity()) return;
      const buyNow = event.submitter?.hasAttribute('data-buy');
      const previousStates = submitButtons.map(button => button.disabled);
      pending = true;
      form.setAttribute('aria-busy', 'true');
      submitButtons.forEach(button => { button.disabled = true; });
      input.readOnly = true;
      updateTotals();
      error.hidden = true;
      success.hidden = true;
      status.textContent = buyNow ? 'Preparando tu compra…' : 'Agregando al carrito…';
      try {
        const response = await fetch(`${base}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: root.dataset.variantId, quantity: q }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'No pudimos agregar el producto. Revisa la disponibilidad e inténtalo de nuevo.');
        status.textContent = `${q === 1 ? 'Agregamos 1 frasco' : `Agregamos ${q} frascos`} a tu carrito.`;
        success.hidden = false;
        if (buyNow) {
          window.location.assign(`${base}checkout`);
          return;
        }
        // This landing uses the native cart page rather than a cached drawer.
        fetch(`${base}cart.js`, { headers: { Accept: 'application/json' } })
          .then(r => r.ok ? r.json() : null)
          .then(cart => {
            if (!cart) return;
            document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
          }).catch(() => {});
      } catch (cause) {
        status.textContent = '';
        error.textContent = cause instanceof TypeError ? 'No pudimos confirmar la conexión. Revisa tu carrito antes de volver a intentar para evitar duplicados.' : cause.message;
        error.hidden = false;
        success.hidden = false;
      } finally {
        pending = false;
        form.removeAttribute('aria-busy');
        submitButtons.forEach((button, i) => { button.disabled = previousStates[i]; });
        input.readOnly = false;
        updateTotals();
      }
    });
  }
  document.querySelectorAll('[data-collagen-landing]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-collagen-landing]').forEach(init);
  });
})();
